import React, { useState, useEffect, useMemo } from 'react'
import Loading from './Loading'
import useData from '../hooks/useData'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import Chart from './Chart'
import Icon from './Icon'
import Input from './Input'
import { put, post } from '../modules/fetch'
import Switch from './Switch'
import { format, subDays } from 'date-fns'

const byUrl = (a, b) => {
    const order = a.keys[0].localeCompare(b.keys[0])
    if (order == 0) {
        return (a.impressions < b.impressions && 1) || -1
    } else {
        return order
    }
}
const byImpression = (a, b) => {
    return (a.impressions < b.impressions && 1) || -1
}
const getPermalinkFromSCURL = (url, site_url) => {
    const value = url.substring(url.indexOf(site_url) + site_url.length + 1)
    // console.log({value})
    if (value === '') {
        return 'homepage'
    }
    return value
}

const URLIsAMP = (url, site_url) => {
    // console.log(url, site_url)
    if (url.substr(url.length - 4) === '?amp') {
        return true
    } else if (~url.indexOf('amp=1')) {
        return true
    }
    return false
}
const URLIsWordpressOrAMP = (url, site_url) => {
    console.log(url, site_url)
    if (url === site_url) {
        return false
    }
    if (url.substr(url.length - 1) === '/') {
        return true
    } else if (url.substr(url.length - 4) === '?amp') {
        return true
    } else if (url.indexOf('amp=1')) {
        return true
    }
    return false
}

const SnippetEdit = (props) => {
    const { site, siteSetState, article_list, keywords, target___site_id, target___article_id, source___article_id, text, title, active } = props
    const [status, setStatus] = useState('ready')
    useEffect(() => {
        !props.id &&
            post('snippet', { keywords, target___site_id, target___article_id, active: 1 })
                .then((r) => console.log(r) || siteSetState({ ...site, target___snippet_array: [...site.target___snippet_array.filter((s) => !s.new), r] }))
    }, [props.id])
    const save = () => {
        setStatus('loading')
        put(`snippet/${props.id}`, { title, text, source___article_id, active }).then((r) => setStatus('saved'))
    }

    const onChange = (prop_name, value) => {
        siteSetState({
            ...site,
            target___snippet_array: site.target___snippet_array.reduce((acc, s) => {
                acc.push((s.id !== props.id && s) || { ...props, [prop_name]: value })
                return acc
            }, []),
        })
        setStatus('needs_saving')
    }
    return (
        <>
            {(!props.id && <Loading text="Creating snippet" />) || (
                <div className={'row' + ((!active && ' muted') || '')}>
                    <div className="col-5">
                        <label htmlFor={`snippet-${props.id}-article`}>Article</label>
                        <Input
                            id={`snippet-${props.id}-article`}
                            type="select"
                            className={(article_list.length && ((!props.source___article_id && 'is-invalid') || 'is-valid')) || ''}
                            options={article_list}
                            value={props.source___article_id || ''}
                            onChange={({ value }) => onChange('source___article_id', value)}
                        />
                        {/* On <Link to={`/article/edit/${props.source___article_id}`}>{props.source___article_title}</Link> <a href={`https://${props.source___site_url}/${props.source___article_permalink!=='homepage'&&props.source___article_permalink||''}`} target="_blank"><Icon name="external" /></a> */}
                        <div className="mt-2">
                            <Switch
                                id={`snippet-${props.id}-active`}
                                className="float-right"
                                onChange={(checked) => onChange('active', checked)}
                                checked={!!active}
                            />
                            <label htmlFor={`snippet-${props.id}-active`}>Visible</label>
                        </div>
                    </div>
                    <div className="col-7">
                        <label htmlFor={`snippet-${props.id}-title`}>Title</label>
                        <Input
                            className="mb-2"
                            id={`snippet-${props.id}-title`}
                            type="text"
                            value={title}
                            onChange={(e) => onChange('title', e.target.value)}
                        />
                        <label htmlFor={`snippet-${props.id}-text`}>Text</label>
                        <Input
                            className={'mb-2' + ((text && (((!~text.indexOf('<a>') || !~text.indexOf('</a>')) && ' is-invalid') || ' is-valid')) || '')}
                            id={`snippet-${props.id}-text`}
                            type="textarea"
                            value={text}
                            onChange={(e) => onChange('text', e.target.value)}
                        />
                        {(text && (!~text.indexOf('<a>') || !~text.indexOf('</a>')) && (
                            <div className="invalid-feedback">A snippet has to contain a link ({'<a></a>'})</div>
                        )) || <div className="valid-feedback">The snippet text is valid</div>}
                        <div
                            className={
                                'mt-2 btn float-right' +
                                ((status === 'loading' && ' disabled') || '') +
                                ((status === 'needs_saving' && ' btn-primary') || ' btn-light')
                            }
                            onClick={save}
                        >
                            {(status === 'loading' && <>Saving...</>) ||
                                (status === 'saved' && (
                                    <>
                                        Saved <Icon name="check" />
                                    </>
                                )) ||
                                'Save'}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

const useSearchConsole = ({ site_id, date }) => {
    let { isLoading: siteIsLoading, data: site, setState: siteSetState } = useData('site/' + site_id + '?scope=seo')
    const { isLoading: scDataIsLoading, data: scdata } = useData(
        'google/search_console?site_id=' +
            site_id +
            '&dimensions[0]=page&dimensions[1]=query&start_date=' +
            format(date[0], 'yyyy-MM-dd') +
            '&end_date=' +
            format(date[1], 'yyyy-MM-dd'),
        (r) => r && r.filter((i) => i.position < 30)
    )
    const { isLoading: scDataSiteIsLoading, data: scdatasite } = useData(
        'google/search_console?site_id=' +
            site_id +
            '&dimensions[0]=date&start_date=' +
            format(date[0], 'yyyy-MM-dd') +
            '&end_date=' +
            format(date[1], 'yyyy-MM-dd'),
        (r) => r && r.filter((i) => i.position < 30)
    )
    const articleList = useData('article?scope=dropdown')
    const article_list = useMemo(
        () =>
            (articleList.data &&
                Array.isArray(articleList.data) && [
                    ...articleList.data
                        .filter((a) => a.site_url)
                        .sort((a, b) => {
                            const val = a.site_url.localeCompare(b.site_url, 'fr', { sensitivity: 'base' })
                            if (val == 0) {
                                return a.title.localeCompare(b.title)
                            } else {
                                return val
                            }
                        })
                        .map((a) => ({ label: a.site_label + ' / ' + a.title, value: a.id })),
                ]) ||
            [],
        [articleList.data]
    )
    const scrows = useMemo(() => (scdata && scdata.filter((r) => r.position > 10 && r.position <= 30).sort(byUrl)) || [], [scdata])
    const article_array = useMemo(
        () =>
            (site &&
                articleList.data
                    ?.filter((a) => a.site_url === site.url)
                    .map((article) => ({
                        ...article,
                        scrows: scrows.filter(
                            (scr) => !!(scr.keys[0] === 'https://' + article.site_url + '/' + (article.permalink !== 'homepage' ? article.permalink : ''))
                        ),
                        scdata: scdata.filter(
                            (scr) => !!(scr.keys[0] === 'https://' + article.site_url + '/' + (article.permalink !== 'homepage' ? article.permalink : ''))
                        ),
                    }))) ||
            [],
        [articleList.data, scrows]
    )
    return { site, siteIsLoading, siteSetState, scdata, scDataIsLoading, scdatasite, scDataSiteIsLoading, articleList, article_list, article_array }
}

const SearchConsole = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const [date, setDate] = useState([subDays(new Date(), 90), new Date()])

    const {
        site,
        siteIsLoading,
        siteSetState,
        scdata,
        scDataIsLoading,
        scdatasite,
        scDataSiteIsLoading,
        articleList,
        article_list,
        article_array,
    } = useSearchConsole({
        site_id: id,
        date,
    })
    const getArticleIdFromSCURL = (url) => {
        if (!url || !site) return null
        url = url.replace('?amp', '')
        const perm = getPermalinkFromSCURL(url, site.url)
        return ((site.article_array || []).find((article) => article.permalink === perm || article.old_permalink === perm) || {}).id
    }
    const getSnippetsFromSCURL = (url) => {
        if (!url) return []
        url = url.replace('?amp', '')
        // console.log('looking for', url, getArticleIdFromSCURL(url))
        return (
            (site &&
                site.target___snippet_array &&
                site.target___snippet_array.filter((snippet) => snippet.target___article_id === getArticleIdFromSCURL(url))) ||
            []
        )
    }

    const addSnippet = (url, keywords) => {
        {
            /* console.log('there', { new: true, target___article_id: getArticleIdFromSCURL(url), target___site_id: id, keywords }) */
        }
        siteSetState({
            ...site,
            target___snippet_array: [
                ...site.target___snippet_array,
                { new: true, target___article_id: getArticleIdFromSCURL(url), target___site_id: id, keywords },
            ],
        })
    }

    const getSnippetsFromSCURLAndQuery = (url, query) => getSnippetsFromSCURL(url).filter((snippet) => snippet.keywords === query)

    const hits =
        (scdata &&
            scdata
                .filter((r) => r.position < 10 && r.impressions > 10)
                .sort(byImpression)
                .slice(0, 10)) ||
        []
    // console.log({ scrows })
    console.log({ articleList })
    console.log({ hits })
    console.log({ article_array })

    const snippets_array = useMemo(() => {
        // console.log('COMPUTING')
        return (
            (scdata &&
                scdata.reduce((acc, r) => {
                    const snippet_array = getSnippetsFromSCURLAndQuery(r.keys[0], r.keys[1]) || []
                    // console.log({snippet_array}, acc)
                    acc = [
                        ...acc,
                        ...snippet_array.map((s) => {
                            return { ...s, keys: r.keys }
                        }),
                    ]
                    return acc
                }, [])) ||
            []
        )
    }, [scdata, site])

    const chartData = useMemo(
        () =>
            (scdatasite &&
                scdatasite
                    .reduce((acc, item) => {
                        acc.push({ name: item.keys[0], clicks: item.clicks, impressions: item.impressions })
                        return acc
                    }, [])
                    .sort((a, b) => (a.name.localeCompare(b.name) && 1) || -1)) ||
            [],
        [scdatasite]
    )
    console.log({ article_array })
    return (
        <React.Fragment>
            {article_array?.map((a) => {
                return (
                    <div key={a.id}>
                        {a.title}
                        <ul>
                            {a.scdata
                                .sort((a, b) => (a.impressions < b.impressions ? 1 : a.impressions === b.impressions ? 0 : -1))
                                .map((r, index) => (
                                    <li key={index}>
                                        {r.clicks}/{r.impressions} - {r.keys[1]} - {r.position}
                                    </li>
                                ))}
                        </ul>
                    </div>
                )
            })}
            {(!siteIsLoading && site && (
                <React.Fragment>
                    <DateRangePicker onChange={setDate} value={date} className="float-right" locale="fr" />
                    <h1>{site.label}</h1>
                    {(scDataSiteIsLoading && <Loading text="Loading impressions and clicks" />) || null}
                    {(!scDataSiteIsLoading && scdatasite && (
                        <>
                            <h2>Impressions and clicks</h2>
                            <p>{site.url}</p>
                            <div className="my-5">
                                <Chart data={chartData} />
                            </div>
                        </>
                    )) ||
                        null}
                    {(!scDataIsLoading && scdata && (
                        <>
                            <h2>Top hits</h2>
                            <p>{site.url}</p>
                            <p>First page on Google &amp; more than 10 impressions</p>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>page</th>
                                        <th>impressions</th>
                                        <th>clicks</th>
                                        <th>keywords</th>
                                        <th>position</th>
                                        <th>snippets</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {hits.map((r, index) => (
                                        <React.Fragment key={`r-${index}`}>
                                            <tr>
                                                <td>{r.keys[0]}</td>
                                                <td>{(r.impressions >= 10 && <strong>{r.impressions}</strong>) || r.impressions}</td>
                                                <td>{r.clicks}</td>
                                                <td>
                                                    <span className="badge badge-light">{r.keys[1]}</span>
                                                </td>
                                                <td>{r.position.toFixed(2)}</td>
                                                <td>
                                                    {(!URLIsAMP(r.keys[0], 'https://' + site.url + '/') && (
                                                        <div className="btn btn-light" onClick={() => addSnippet(r.keys[0], r.keys[1])}>
                                                            <Icon name="add" />
                                                            Snippet
                                                        </div>
                                                    )) ||
                                                        null}
                                                </td>
                                            </tr>
                                            {(snippets_array.filter((s) => s.keys[0] === r.keys[0] && s.keys[1] === r.keys[1]).length &&
                                                snippets_array
                                                    .filter((s) => s.keys[0] === r.keys[0] && s.keys[1] === r.keys[1])
                                                    .map((snippet) => (
                                                        <tr key={`snippet-${snippet.id}`}>
                                                            <td colSpan="6">
                                                                <SnippetEdit {...snippet} site={site} siteSetState={siteSetState} article_list={article_list} />
                                                            </td>
                                                        </tr>
                                                    ))) ||
                                                null}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )) || <Loading text="Fetching top hits" />}
                    {(!scDataIsLoading && scdata && (
                        <>
                            <h2>Low hanging fruits</h2>
                            <p>{site.url}</p>
                            <table className="table">
                                <thead>
                                    <tr>
                                        {/* <th>page</th> */}
                                        <th>keywords</th>
                                        <th>impressions</th>
                                        <th>clicks</th>
                                        <th>position</th>
                                        <th>snippets</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {article_array?.map(
                                        (article) =>
                                            (article.scrows?.length && (
                                                <React.Fragment key={`r-${article.id}`}>
                                                    <tr>
                                                        <td colSpan="6">
                                                            <GoogleResult url={article.scrows[0]?.keys?.[0]} article={article} />
                                                        </td>
                                                    </tr>
                                                    {article.scrows.map((r, index) => (
                                                        <React.Fragment key={`r-${article.id}-${index}`}>
                                                            <tr>
                                                                {/* <td>{r.keys[0]}</td> */}
                                                                <td>
                                                                    <span className="badge badge-light">{r.keys[1]}</span>
                                                                </td>
                                                                <td>{(r.impressions >= 10 && <strong>{r.impressions}</strong>) || r.impressions}</td>
                                                                <td>{r.clicks}</td>
                                                                <td>{r.position.toFixed(2)}</td>
                                                                <td>
                                                                    {(!URLIsAMP(r.keys[0], 'https://' + site.url + '/') && (
                                                                        <div className="btn btn-light" onClick={() => addSnippet(r.keys[0], r.keys[1])}>
                                                                            <Icon name="add" className="mr-2" />
                                                                            Snippet
                                                                        </div>
                                                                    )) ||
                                                                        null}
                                                                </td>
                                                            </tr>
                                                            {(snippets_array.filter((s) => s.keys[0] === r.keys[0] && s.keys[1] === r.keys[1]).length &&
                                                                snippets_array
                                                                    .filter((s) => s.keys[0] === r.keys[0] && s.keys[1] === r.keys[1])
                                                                    .map((snippet) => (
                                                                        <tr key={`snippet-${snippet.id}`}>
                                                                            <td colSpan="6">
                                                                                <SnippetEdit
                                                                                    {...snippet}
                                                                                    site={site}
                                                                                    siteSetState={siteSetState}
                                                                                    article_list={article_list}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    ))) ||
                                                                null}
                                                        </React.Fragment>
                                                    ))}
                                                </React.Fragment>
                                            )) ||
                                            null
                                    )}
                                </tbody>
                            </table>
                        </>
                    )) || <Loading text="Fetching low hanging fruits" />}
                </React.Fragment>
            )) || <Loading text="Loading site data" />}
        </React.Fragment>
    )
}

const GoogleResult = (props) => {
    const url = props.url?.replace('https://', '').replace('www.', '')
    const base = url.substring(0, url.indexOf('/'))
    const append = url?.substring(url?.lastIndexOf('/') + 1)
    const title = props.article.title
    const id = props.article.id
    return (
        <div className="google-result">
            <div className="url">
                {base}
                {(append && (
                    <>
                        {' '}
                        › <span>{append}</span>
                    </>
                )) ||
                    null}
            </div>
            <h3>
                <a href={'/article/edit/' + id}>{title}</a>
            </h3>
        </div>
    )
}

export default SearchConsole
